export enum MEDIALINKS {
  FACEBOOK = 'facebook',
  YOUTUBE = 'youtube',
}
